import {
    cloneElement,
    type FC
} from "react";
import PreferenceMenuItem from "./item";
import type {
    PreferenceFormProps
} from "../type";
import DropdownMenu from "../../../components/dropdownMenu";

type PreferenceMenuProps = Pick<PreferenceFormProps, "customLocalize" | "customTheme" | "isDisabled" | "activeKey" | "onSelect" | "options" | "trigger" | "title">;

const PreferenceMenu: FC<PreferenceMenuProps> = ({
    customLocalize,
    customTheme,
    isDisabled,
    activeKey,
    onSelect,
    options,
    trigger,
    title
}) => {
    const handlePress = () => {};

    return <DropdownMenu
        customLocalize={customLocalize}
        customTheme={customTheme}
        title={title}
    >
        <DropdownMenu.Trigger
            isDisabled={isDisabled}
        >
            {cloneElement(trigger, {
                onPress: handlePress
            })}
        </DropdownMenu.Trigger>
        <DropdownMenu.Content>
            <DropdownMenu.RadioGroup
                onChange={onSelect}
                value={activeKey}
            >
                {
                    options.map((option) => {
                        return <PreferenceMenuItem
                            customTheme={customTheme}
                            key={option.key}
                            option={option}
                        />;
                    })
                }
            </DropdownMenu.RadioGroup>
        </DropdownMenu.Content>
    </DropdownMenu>;
};
export default PreferenceMenu;
